import { COLORS } from '../Theme'

export const ToastStyles = `
  .Toastify__toast-container {
    margin-bottom: 16px;
  }
  .Toastify__toast {
    border-radius: 4px;
    font-size: 16px;
    line-height: 24px;
    color: ${COLORS.WHITE};
    background: ${COLORS.BRAND_DEFAULT};
    padding: 12px 16px;
    min-height: 0;

    & svg {
      width: 16px;
      height: 16px;
    }

    &.hideButton {
      .Toastify__close-button {
        display: none;
      }
    }
  }

  .Toastify__close-button {
    display: inline-block;
    opacity: 1;
    height: 24px;
    align-self: center;

    & svg {
      width: 20px;
      height: 20px;
    }
  }

  .Toastify__toast-body {
    margin: 0;
    padding: 0;
    text-align: left;
  }

  .Toastify__toast--info {
    & svg path {
      fill: ${COLORS.WHITE};
    }

    & .Toastify__close-button {
      color: ${COLORS.WHITE};
    }

    &.light {
      background-color: ${COLORS.BRAND_LIGHT};
      color: ${COLORS.BRAND_DEFAULT};

      & svg path {
        fill: ${COLORS.BRAND_DEFAULT};
      }

      & .Toastify__close-button {
        fill: ${COLORS.BRAND_DEFAULT};
      }
    }
  }

  .Toastify__toast--error {
    color: ${COLORS.WHITE};
    background: ${COLORS.ERROR_DEFAULT};

    & svg path {
      fill: ${COLORS.WHITE};
    }

    & .Toastify__close-button {
      color: ${COLORS.WHITE};
    }

    &.light {
      color: ${COLORS.ERROR_DEFAULT};
      background: ${COLORS.ERROR_LIGHT};

      & svg path {
        fill: ${COLORS.ERROR_DEFAULT};
      }

      & .Toastify__close-button {
        color: ${COLORS.ERROR_DEFAULT};
      }
    }
  }

  .Toastify__toast--warning {
    color: ${COLORS.WHITE};
    background: ${COLORS.WARNING_DEFAULT};

    & svg path {
      fill: ${COLORS.WHITE};
    }

    .Toastify__close-button {
      color: ${COLORS.WHITE};
    }

    &.light {
      color: ${COLORS.WARNING_DEFAULT};
      background: ${COLORS.WARNING_LIGHT};

      & svg path {
        fill: ${COLORS.WARNING_DEFAULT};
      }

      .Toastify__close-button {
        color: ${COLORS.WARNING_DEFAULT};
      }
    }
  }

  .Toastify__toast--success {
    color: ${COLORS.WHITE};
    background: ${COLORS.SUCCESS_DEFAULT};

    & svg path {
      fill: ${COLORS.WHITE};
    }

    & .Toastify__close-button {
      color: ${COLORS.WHITE};
    }
    &.light {
      & svg path {
        fill: ${COLORS.SUCCESS_DEFAULT};
      }

      color: ${COLORS.SUCCESS_DEFAULT};
      background: ${COLORS.SUCCESS_LIGHT};

      & .Toastify__close-button {
        color: ${COLORS.SUCCESS_DEFAULT};
      }
    }
  }
`
